//Built-in libraries
import type { ChangeEvent } from 'react';

//Third party libraries

//Custom components
import Button from '@/components/UI/Button';
import Input from '@/components/UI/Form/Input';
import MoneyInput from '@/components/UI/Form/MoneyInput';
import ReactSelect from '@/components/UI/Form/ReactSelect';
import Modal, { type ModalProps } from '@/components/UI/Modal';
import type { ReactSelectOption } from '@/types/Constants';
import { relation } from './constants';

//Services

//Assets andd Miscellaneous

//Component Begin

interface IAddDevelopmentTeamMemberFormProps extends ModalProps {
  modalHandler: () => void;
  income: { [key: string]: { [key: string]: any } };
  inputChangedHandler: (value: string | number | boolean | ChangeEvent<HTMLInputElement> | undefined, name: string) => void;
  onAddIncomeHandler: () => void;
  isEditing: boolean;
  updateIncomeHandler: () => void;
}

export default function AddHouseholdIncomeForm({
  modalHandler,
  isEditing,
  income,
  inputChangedHandler,
  onAddIncomeHandler,
  updateIncomeHandler,
  ...rest
}: IAddDevelopmentTeamMemberFormProps) {
  return (
    <Modal width='min-w-1/2'>
      <h2 className='mt-0'>{`${isEditing ? 'Edit' : 'Add New'} Family Member`}</h2>
      <div>
        <section className='space-y-4'>
          <div className='grid grid-cols-3 gap-5'>
            <Input
              label='Family Member Name'
              id='family-member-name'
              name='familyMemberName'
              type='text'
              value={income?.familyMemberName.value}
              error={income?.familyMemberName?.error}
              onChange={(e: ChangeEvent<HTMLInputElement>) => {
                inputChangedHandler(e.target.value, e.target.name);
              }}
              onBlur={(e: ChangeEvent<HTMLInputElement>) => {
                inputChangedHandler(e.target.value, e.target.name);
              }}
            />
            <Input
              // customClassName='col-span-3'
              label='Age'
              id='age'
              name='age'
              type='number'
              value={income?.age.value}
              error={income?.age?.error}
              onChange={(e: ChangeEvent<HTMLInputElement>) => {
                inputChangedHandler(e.target.valueAsNumber, e.target.name);
              }}
              onBlur={(e: ChangeEvent<HTMLInputElement>) => {
                inputChangedHandler(e.target.valueAsNumber, e.target.name);
              }}
            />
            <div>
              <ReactSelect
                label='Relation'
                id='relation'
                name='relation'
                options={relation.map((dt) => ({
                  label: dt,
                  value: dt,
                }))}
                value={{
                  label: income?.relation.value,
                  value: income?.relation.value,
                }}
                placeholder='Select'
                error={income?.relation?.error}
                onChange={(option) => {
                  inputChangedHandler((option as ReactSelectOption).value, 'relation');
                }}
              />
            </div>

            <h4 className='col-span-3'>Please mention the Income Sources</h4>
            <div className='relative'>
              <MoneyInput
                label='Yearly Income'
                id='wages'
                value={income?.wages.value}
                name='wages'
                onValueChange={(target) => {
                  inputChangedHandler(target.floatValue, 'wages');
                }}
              />
            </div>
            <div className='relative'>
              <MoneyInput
                label='Benefits/Pensions'
                id='pensions'
                name='pensions'
                value={income?.pensions.value}
                error={income?.pensions?.error}
                onValueChange={(target) => {
                  inputChangedHandler(target.floatValue, 'pensions');
                }}
              />
            </div>
            <div className='relative'>
              <MoneyInput
                label='Public Assistance'
                id='public-assistance'
                name='publicAssistance'
                value={income?.publicAssistance.value}
                error={income?.publicAssistance?.error}
                onValueChange={(target) => {
                  inputChangedHandler(target.floatValue, 'publicAssistance');
                }}
              />
            </div>
            <div className='relative'>
              <MoneyInput
                label='Social Security Income'
                id='ssi'
                name='ssi'
                value={income?.ssi.value}
                error={income?.ssi?.error}
                onValueChange={(target) => {
                  inputChangedHandler(target.floatValue, 'ssi');
                }}
              />
            </div>
            <div className='relative'>
              <MoneyInput
                label='Other Income'
                id='other-income'
                name='otherIncome'
                value={income?.otherIncome.value}
                error={income?.otherIncome?.error}
                onValueChange={(target) => {
                  inputChangedHandler(target.floatValue, 'otherIncome');
                }}
              />
            </div>
          </div>
        </section>
        <div className='flex justify-end gap-4 mt-10'>
          <Button disabled={false} label='Cancel' type='button' btnStyle='neutral' onClick={modalHandler} />
          <Button
            label={`${isEditing ? 'Save' : 'Add'}`}
            type='button'
            btnStyle='primary'
            onClick={isEditing ? updateIncomeHandler : onAddIncomeHandler}
          />
        </div>
      </div>
    </Modal>
  );
}
